import React, { useCallback } from 'react';
import { useProviderHelpers } from './ProviderHelpers';

const Context = React.createContext();

export const GmailGroupsProvider = ({ children }) => {
    const { data, execute, clearData } = useProviderHelpers();

    const selectRecord = useCallback(async (props) => {
        await execute({ scope: 'select', url: `GmailGroup/${props.groupId}`, method: 'GET', secure: true });
    }, [execute]);

    const newRecord = useCallback(async (props) => {
        await execute({ scope: 'new', payload: { status: 200, body: props } });
    }, [execute]);

    const createRecord = useCallback(async (props) => {
        await execute({ scope: 'create', url: `GmailGroup`, method: 'POST', payload: props, secure: true });
    }, [execute]);

    const updateRecord = useCallback(async (props) => {
        await execute({ scope: 'update', url: `GmailGroup/${props.groupId}`, method: 'PUT', payload: props, secure: true });
    }, [execute]);

    const listRecords = useCallback(async () => {
        let url = 'GmailGroup';
        await execute({ scope: 'list', url: url, method: 'GET', secure: true });
    }, [execute]);

    const groupTypes = useCallback(async () => {
        await execute({ scope: 'listGroupTypes', url: `GmailGroup/GroupTypes`, method: 'GET', secure: true });

    }, [execute]);

    const deleteRecord = useCallback(async (props) => {
        await execute({ scope: 'delete', url: `GmailGroup/${props.groupId}`, method: 'DELETE', secure: true });
    }, [execute]);

    const value = { selectRecord, listRecords, newRecord, groupTypes, deleteRecord, updateRecord, createRecord, data, clearData };

    return (
        <Context.Provider value={value}>
            {children}
        </Context.Provider>
    );
};

export const useGmailGroupStore = () => React.useContext(Context);
